import { FC, PropsWithChildren } from 'react';

export interface IProps {
  fullLocalAddress?: string;
  onClick?: (e: any) => void;
}

const GoogleMapAnchor: FC<PropsWithChildren<IProps>> = (props) => {
  const { fullLocalAddress, children, onClick } = props;

  if (!fullLocalAddress) {
    return <>{children}</>;
  }

  return (
    <a
      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        fullLocalAddress
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      {children}
    </a>
  );
};

export default GoogleMapAnchor;
